import React, { useState } from "react";
import { Box, Typography, IconButton, TextField, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import FlightIcon from "@mui/icons-material/Flight";
import HotelIcon from "@mui/icons-material/Hotel";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// LocalFloristIcon removed - no longer used in redesign
import CategoryIcon from "@mui/icons-material/Category";
import { BasicModal } from "../BasicModal/BasicModal";
import { useWindowSize } from "@uidotdev/usehooks";
import { useSnackbar } from "notistack";
import {
	TRAVEL_KIT_MODAL,
	textFieldSx,
	modalContentSx,
	primaryButtonSx,
	secondaryButtonSx,
} from "./TravelKitModalStyles";

// Template102: Travel Kit - Info Básica del Viaje
const Template102 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
	registerScrollContainer,
	isViewer = false,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const { enqueueSnackbar } = useSnackbar();

	const setScrollContainerRef = (domNode) => {
		if (typeof registerScrollContainer === "function") {
			registerScrollContainer(domNode);
		}
	};

	// Obtener datos desde page.data (con fallback a raíz y data.data)
	const pageData = page.data || {};
	const sectionsSource =
		Array.isArray(page?.sections) && page.sections.length > 0
			? page.sections
			: Array.isArray(pageData?.sections) && pageData.sections.length > 0
			? pageData.sections
			: Array.isArray(page?.data?.data?.sections) && page.data.data.sections.length > 0
			? page.data.data.sections
			: null;
	const [sections, setSections] = useState(() => {
		if (sectionsSource?.length > 0) {
			return sectionsSource;
		}
		// Datos por defecto
		// Paleta pastel scrapbook + textos más cálidos
		return [
			{
				id: 1,
				type: "flight",
				title: "Vuelo de ida",
				icon: "✈️",
				color: "#D4B8E8",
				fields: [
					{ label: "Mi aerolínea", value: "" },
					{ label: "Nº de vuelo", value: "" },
					{ label: "Día del vuelo", value: "" },
					{ label: "Hora de salida", value: "" },
					{ label: "Salida desde", value: "" },
					{ label: "Llegada a", value: "" },
					{ label: "Localizador", value: "" },
				],
			},
			{
				id: 2,
				type: "flight",
				title: "Vuelo de vuelta",
				icon: "✈️",
				color: "#D4B8E8",
				fields: [
					{ label: "Mi aerolínea", value: "" },
					{ label: "Nº de vuelo", value: "" },
					{ label: "Día del vuelo", value: "" },
					{ label: "Hora de salida", value: "" },
					{ label: "Salida desde", value: "" },
					{ label: "Llegada a", value: "" },
					{ label: "Localizador", value: "" },
				],
			},
			{
				id: 3,
				type: "hotel",
				title: "Alojamiento",
				icon: "🏨",
				color: "#A8D5BA",
				fields: [
					{ label: "Nombre del sitio", value: "" },
					{ label: "Dirección", value: "" },
					{ label: "Entrada", value: "" },
					{ label: "Salida", value: "" },
					{ label: "Nº de reserva", value: "" },
					{ label: "Teléfono", value: "" },
				],
			},
			{
				id: 4,
				type: "contact",
				title: "Por si acaso",
				icon: "📞",
				color: "#F5C6D8",
				fields: [
					{ label: "Embajada", value: "" },
					{ label: "Seguro", value: "" },
					{ label: "Contacto allí", value: "" },
					{ label: "Emergencias", value: "112" },
				],
			},
		];
	});

	const [editModal, setEditModal] = useState(false);
	const [editingSection, setEditingSection] = useState(null);
	const [tempFields, setTempFields] = useState([]);
	const [tempTitle, setTempTitle] = useState("");
	const [headerEditModal, setHeaderEditModal] = useState(false);
	const [tempHeaderText, setTempHeaderText] = useState("");

	const updatePageData = (newSections) => {
		updatePage({
			...page,
			data: {
				...pageData,
				sections: newSections,
			},
		});
	};

	const handleEditSection = (sectionIndex) => {
		setEditingSection(sectionIndex);
		setTempFields([...sections[sectionIndex].fields]);
		setTempTitle(sections[sectionIndex].title);
		setEditModal(true);
	};

	const handleSaveSection = () => {
		const newSections = [...sections];
		newSections[editingSection].fields = tempFields;
		newSections[editingSection].title = tempTitle;
		setSections(newSections);
		updatePageData(newSections);
		setEditModal(false);
	};

	const handleFieldChange = (fieldIndex, value) => {
		const newFields = [...tempFields];
		newFields[fieldIndex].value = value;
		setTempFields(newFields);
	};

	const handleAddField = () => {
		setTempFields([...tempFields, { label: "Nuevo campo", value: "" }]);
	};

	const handleDeleteField = (fieldIndex) => {
		const newFields = tempFields.filter((_, i) => i !== fieldIndex);
		setTempFields(newFields);
	};

	const handleCopyValue = (value) => {
		if (value) {
			navigator.clipboard.writeText(value);
			enqueueSnackbar("Copiado al portapapeles", { variant: "success" });
		}
	};

	const handleAddSection = (type) => {
		const typeConfig = {
			flight: {
				title: "Otro vuelo",
				icon: "✈️",
				color: "#D4B8E8",
				fields: [
					{ label: "Mi aerolínea", value: "" },
					{ label: "Nº de vuelo", value: "" },
					{ label: "Día", value: "" },
					{ label: "Hora", value: "" },
				],
			},
			hotel: {
				title: "Dónde me quedo",
				icon: "🏨",
				color: "#A8D5BA",
				fields: [
					{ label: "Nombre del sitio", value: "" },
					{ label: "Dirección", value: "" },
					{ label: "Entrada", value: "" },
					{ label: "Salida", value: "" },
				],
			},
			contact: {
				title: "Por si acaso",
				icon: "📞",
				color: "#F5C6D8",
				fields: [
					{ label: "Nombre", value: "" },
					{ label: "Teléfono", value: "" },
				],
			},
		};

		const config = typeConfig[type];
		const newId = Math.max(0, ...sections.map((s) => s.id)) + 1;
		const newSections = [
			...sections,
			{
				id: newId,
				type,
				...config,
			},
		];
		setSections(newSections);
		updatePageData(newSections);
	};

	const handleDeleteSection = (sectionIndex) => {
		const newSections = sections.filter((_, i) => i !== sectionIndex);
		setSections(newSections);
		updatePageData(newSections);
	};

	const getIcon = (type, sz = 20, color = "inherit") => {
		const sx = { fontSize: sz, color };
		switch (type) {
			case "flight":
				return <FlightIcon sx={sx} />;
			case "hotel":
				return <HotelIcon sx={sx} />;
			case "contact":
				return <ContactPhoneIcon sx={sx} />;
			default:
				return <CategoryIcon sx={sx} />;
		}
	};

	const templateItemProps = {
		"data-template-item": true,
		className: "template-item",
	};

	// Paleta scrapbook viva: colores saturados pero dulces
	const PALETTE = {
		flight: {
			bg: "#C9A4E8",
			header: "#B388D9",
			accent: "#9B6DC6",
			light: "#F0E6F8",
		},
		hotel: {
			bg: "#8ECFAB",
			header: "#6DBF92",
			accent: "#4DA87A",
			light: "#E4F5EB",
		},
		contact: {
			bg: "#F4A6BC",
			header: "#EF8BA7",
			accent: "#E06B8E",
			light: "#FDE8EF",
		},
		default: {
			bg: "#D4B8E8",
			header: "#C09ED8",
			accent: "#A880C8",
			light: "#F0E6F8",
		},
	};

	const getColorSet = (type, color) => {
		return PALETTE[type] || PALETTE.default;
	};

	// Washi tape patterns por sección (alternando)
	const washiPatterns = [
		"repeating-linear-gradient(45deg, transparent 0px, transparent 4px, rgba(255,255,255,0.4) 4px, rgba(255,255,255,0.4) 6px)",
		"repeating-linear-gradient(-45deg, transparent 0px, transparent 3px, rgba(255,255,255,0.35) 3px, rgba(255,255,255,0.35) 5px)",
		"repeating-linear-gradient(90deg, transparent 0px, transparent 5px, rgba(255,255,255,0.3) 5px, rgba(255,255,255,0.3) 7px)",
	];

	const headerText = page.texts?.[0]?.content || "Info del Viaje";

	const handleOpenHeaderEdit = () => {
		setTempHeaderText(headerText);
		setHeaderEditModal(true);
	};

	const handleSaveHeaderText = () => {
		const texts = Array.isArray(page.texts) ? [...page.texts] : [];
		if (texts.length === 0)
			texts.push({ content: "Info del Viaje", isEditing: false });
		texts[0] = { ...texts[0], content: tempHeaderText || "Info del Viaje" };
		updatePage({ ...page, texts });
		setHeaderEditModal(false);
	};

	return (
		<Box
			{...templateItemProps}
			sx={{
				display: "flex",
				flexDirection: "column",
				//height: "100%",
				//minHeight: "100%",
				width: "100%",
				backgroundColor: backgroundColor || "#FFF6F0",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				position: "relative",
				zIndex: 1,
				pointerEvents: "none",
				"& [data-template-item]": { pointerEvents: "auto" },
				//"& [data-template102-scroll]": { pointerEvents: "auto" },
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				// Textura sutil de fondo tipo papel craft
				backgroundImage: `
					radial-gradient(ellipse at 20% 50%, rgba(201,164,232,0.08) 0%, transparent 50%),
					radial-gradient(ellipse at 80% 20%, rgba(244,166,188,0.08) 0%, transparent 50%),
					radial-gradient(ellipse at 50% 80%, rgba(142,207,171,0.08) 0%, transparent 50%)
				`,
			}}
		>
			{/* Header: mismo estilo que Template104 - washi strip + sticker */}
			<Box
				data-block-id="header"
				sx={{
					position: "sticky",
					top: 0,
					zIndex: 10,
					padding: isSmallScreen ? "12px 16px" : "16px 20px",
					backgroundColor: "rgb(248, 250, 252)",
					backgroundImage: `repeating-linear-gradient(
						95deg,
						transparent,
						transparent 6px,
						rgba(245, 230, 200, 0.5) 6px,
						rgba(245, 230, 200, 0.5) 9px
					)`,
					borderBottom: "3px dashed rgba(92, 58, 69, 0.2)",
					boxShadow: "0 4px 12px rgba(245, 230, 200, 0.4)",
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						flexWrap: "wrap",
						gap: 1,
					}}
				>
					<Box
						{...templateItemProps}
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							handleOpenHeaderEdit();
						}}
						onMouseDown={(e) => e.stopPropagation()}
						sx={{
							display: "inline-flex",
							alignItems: "center",
							gap: 1.5,
							backgroundColor: "rgba(255,255,255,0.95)",
							borderRadius: "24px",
							padding: "10px 18px",
							boxShadow:
								"0 3px 14px rgba(232, 180, 188, 0.3), 0 1px 3px rgba(0,0,0,0.06)",
							border: "2px solid rgba(245, 230, 200, 0.9)",
							transform: "rotate(-1.2deg)",
							cursor: "pointer",
							"&:hover": {
								backgroundColor: "rgba(255,248,245,0.98)",
							},
						}}
					>
						<FlightIcon sx={{ fontSize: 22, color: "#E8B4BC" }} />
						<Typography
							sx={{
								fontSize: "17px !important",
								fontWeight: "800 !important",
								color: "#5C3A45",
								pointerEvents: "none",
							}}
							dangerouslySetInnerHTML={{ __html: headerText }}
						/>
						<IconButton
							{...templateItemProps}
							className={[templateItemProps?.className, "hide-in-viewer"].filter(Boolean).join(" ")}
							onClick={(e) => {
								e.stopPropagation();
								e.preventDefault();
								if (isViewer) return;
								handleOpenHeaderEdit();
							}}
							onMouseDown={(e) => e.stopPropagation()}
							size="small"
							sx={{
								color: "#B8959E",
								padding: "4px",
								"&:hover": {
									color: "#E8B4BC",
									backgroundColor: "rgba(232, 180, 188, 0.2)",
								},
							}}
							title="Editar título"
						>
							<EditIcon sx={{ fontSize: 18 }} />
						</IconButton>
					</Box>
				</Box>
			</Box>

			{/* Content */}
			<Box
				ref={setScrollContainerRef}
				data-template102-scroll
				sx={{
					flex: 1,
					minHeight: 0,
					overflow: "auto",
					WebkitOverflowScrolling: "touch",
					padding: isSmallScreen ? "20px 14px 14px" : "26px 20px 16px",
				}}
			>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
					{sections.map((section, sectionIndex) => {
						const colors = getColorSet(section.type, section.color);
						const rotation = ["-1.2deg", "0.8deg", "-0.6deg", "1deg"][
							sectionIndex % 4
						];
						const washiPattern =
							washiPatterns[sectionIndex % washiPatterns.length];

						return (
							<Box
								key={section.id}
								data-block-id={`text-${sectionIndex + 1}`}
								sx={{
									transform: `rotate(${rotation})`,
									transition: "transform 0.25s ease",
								}}
							>
								{/* Washi tape superior con patrón visible */}
								<Box
									sx={{
										height: 14,
										marginLeft: "12%",
										marginRight: "20%",
										backgroundColor: colors.bg,
										backgroundImage: washiPattern,
										borderRadius: "3px 3px 0 0",
										boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
										transform: `rotate(${
											sectionIndex % 2 === 0 ? "0.5deg" : "-0.3deg"
										})`,
										position: "relative",
										zIndex: 1,
										// Bordes irregulares tipo cinta cortada
										clipPath: "polygon(2% 0%, 98% 2%, 100% 100%, 0% 98%)",
									}}
								/>

								{/* Tarjeta principal */}
								<Box
									sx={{
										backgroundColor: "#FFFEFB",
										borderRadius: "4px 4px 18px 18px",
										overflow: "hidden",
										boxShadow: `0 8px 28px ${colors.bg}33, 0 2px 8px rgba(0,0,0,0.05)`,
										border: `2px solid ${colors.bg}55`,
										borderTop: "none",
										position: "relative",
										// Textura papel sutil
										backgroundImage: `
											linear-gradient(180deg, ${colors.light}44 0%, transparent 30%),
											repeating-linear-gradient(0deg, transparent, transparent 24px, ${colors.bg}11 24px, ${colors.bg}11 25px)
										`,
									}}
								>
									{/* Section Header - etiqueta con profundidad */}
									<Box
										sx={{
											background: `linear-gradient(135deg, ${colors.header} 0%, ${colors.bg} 100%)`,
											padding: "13px 16px",
											display: "flex",
											alignItems: "center",
											justifyContent: "space-between",
											position: "relative",
											// Patrón diagonal sutil
											"&::before": {
												content: '""',
												position: "absolute",
												inset: 0,
												backgroundImage:
													"repeating-linear-gradient(60deg, transparent 0px, transparent 6px, rgba(255,255,255,0.12) 6px, rgba(255,255,255,0.12) 8px)",
											},
										}}
									>
										<Box
											sx={{
												display: "flex",
												alignItems: "center",
												gap: 1.5,
												position: "relative",
												zIndex: 1,
											}}
										>
											{getIcon(section.type, 18, "#fff")}
											<Typography
												sx={{
													color: "#fff",
													fontWeight: "700 !important",
													fontSize: "14px !important",
													textShadow: "0 1px 3px rgba(0,0,0,0.12)",
													letterSpacing: "0.3px",
												}}
											>
												{section.title}
											</Typography>
										</Box>
										<Box
											className="hide-in-viewer"
											sx={{
												display: "flex",
												gap: 0.25,
												position: "relative",
												zIndex: 1,
											}}
										>
											<IconButton
												{...templateItemProps}
												onClick={() => !isViewer && handleEditSection(sectionIndex)}
												size="small"
												sx={{
													color: "rgba(255,255,255,0.9)",
													"&:hover": {
														backgroundColor: "rgba(255,255,255,0.2)",
													},
												}}
											>
												<EditIcon sx={{ fontSize: 17, pointerEvents: "none" }} />
											</IconButton>
											<IconButton
												{...templateItemProps}
												onClick={() => !isViewer && handleDeleteSection(sectionIndex)}
												size="small"
												sx={{
													color: "rgba(255,255,255,0.9)",
													"&:hover": {
														backgroundColor: "rgba(255,255,255,0.2)",
														color: "#fff",
													},
												}}
											>
												<DeleteIcon sx={{ fontSize: 17, pointerEvents: "none" }} />
											</IconButton>
										</Box>
									</Box>

									{/* Section Fields - estilo libreta */}
									<Box
										sx={{
											padding: isSmallScreen
												? "12px 14px 16px"
												: "14px 18px 18px",
											display: "grid",
											gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 1fr",
											gap: isSmallScreen ? 0 : "0 16px",
											alignItems: "start",
										}}
									>
										{section.fields.map((field, fieldIndex) => (
											<Box
												key={fieldIndex}
												sx={{
													display: "flex",
													alignItems: "center",
													justifyContent: "space-between",
													gap: 0.5,
													padding: "10px 4px 8px",
													borderBottom: `1.5px dotted ${colors.bg}66`,
													minWidth: 0,
													transition: "background 0.15s",
													"&:hover": {
														backgroundColor: `${colors.light}55`,
														borderRadius: "6px",
													},
												}}
											>
												<Box sx={{ flex: 1, minWidth: 0 }}>
													<Typography
														sx={{
															fontSize: "10px !important",
															color: colors.accent,
															fontWeight: "700 !important",
															letterSpacing: "0.8px",
															textTransform: "uppercase",
															marginBottom: "3px",
														}}
													>
														{field.label}
													</Typography>
													<Typography
														sx={{
															fontSize: "13px !important",
															color: field.value ? "#3D2433" : "#B5A0AA",
															fontWeight: field.value
																? "600 !important"
																: "400 !important",
															fontStyle: field.value ? "normal" : "italic",
														}}
														{...templateItemProps}
												        onClick={() => !isViewer && handleEditSection(sectionIndex)}
													>
														{field.value || "Escribir aquí..."}
													</Typography>
												</Box>
												{field.value && (
													<IconButton
														{...templateItemProps}
														onClick={() => handleCopyValue(field.value)}
														size="small"
														sx={{
															flexShrink: 0,
															color: colors.bg,
															"&:hover": {
																color: colors.accent,
																backgroundColor: `${colors.light}88`,
															},
														}}
													>
														<ContentCopyIcon sx={{ fontSize: 14 }} />
													</IconButton>
												)}
											</Box>
										))}
									</Box>
								</Box>
							</Box>
						);
					})}

					{/* Botones añadir - estilo sticker (oculto en viewer) */}
					<Box
						className="hide-in-viewer"
						sx={{
							display: "flex",
							gap: 1.5,
							flexWrap: "wrap",
							justifyContent: "center",
							padding: "20px 0 28px",
						}}
					>
						{[
							{
								type: "flight",
								addLabel: "Añadir vuelo",
								color: PALETTE.flight.bg,
								hoverColor: PALETTE.flight.header,
							},
							{
								type: "hotel",
								addLabel: "Añadir alojamiento",
								color: PALETTE.hotel.bg,
								hoverColor: PALETTE.hotel.header,
							},
							{
								type: "contact",
								addLabel: "Añadir contacto",
								color: PALETTE.contact.bg,
								hoverColor: PALETTE.contact.header,
							},
						].map((item, i) => (
							<Button
								key={item.type}
								{...templateItemProps}
								className={[templateItemProps?.className, "hide-in-viewer"].filter(Boolean).join(" ")}
								onClick={() => !isViewer && handleAddSection(item.type)}
								sx={{
									textTransform: "none",
									fontSize: "12px",
									fontWeight: 700,
									color: "#fff",
									background: `linear-gradient(135deg, ${item.color} 0%, ${item.hoverColor} 100%)`,
									borderRadius: "16px",
									padding: "9px 16px",
									border: "2.5px solid rgba(255,255,255,0.6)",
									boxShadow: `0 4px 14px ${item.color}44, 0 1px 4px rgba(0,0,0,0.06)`,
									transform: `rotate(${
										i === 0 ? "-1.5deg" : i === 1 ? "0.8deg" : "-0.5deg"
									})`,
									gap: 0.75,
									"&:hover": {
										background: `linear-gradient(135deg, ${item.hoverColor} 0%, ${item.color} 100%)`,
										boxShadow: `0 6px 20px ${item.color}55, 0 2px 8px rgba(0,0,0,0.08)`,
										transform: `rotate(${
											i === 0 ? "-1.5deg" : i === 1 ? "0.8deg" : "-0.5deg"
										}) translateY(-2px)`,
									},
									transition: "all 0.2s ease",
								}}
							>
								{getIcon(item.type, 18)}
								{item.addLabel}
							</Button>
						))}
					</Box>
				</Box>
			</Box>

			{/* Edit Modal - diseño coherente con dashboard (oculto en viewer) */}
			<Box className="hide-in-viewer">
			<BasicModal
				width={480}
				showModal={editModal}
				handleClose={() => setEditModal(false)}
				contentSx={modalContentSx}
			>
				<Box sx={{ p: 3, maxHeight: "70vh", overflow: "auto" }}>
					<Typography
						sx={{
							fontSize: "18px !important",
							fontWeight: 700,
							color: TRAVEL_KIT_MODAL.textPrimary,
							mb: 2,
							fontFamily: "'Inter', sans-serif",
						}}
					>
						Editar sección
					</Typography>

					<TextField
						label="Título de la sección"
						value={tempTitle}
						onChange={(e) => setTempTitle(e.target.value)}
						fullWidth
						size="small"
						margin="normal"
						sx={textFieldSx}
					/>

					<Typography
						sx={{
							fontSize: "13px !important",
							fontWeight: 600,
							color: TRAVEL_KIT_MODAL.textMuted,
							mt: 2.5,
							mb: 1.5,
							fontFamily: "'Inter', sans-serif",
						}}
					>
						Campos
					</Typography>

					{tempFields.map((field, index) => (
						<Box
							key={index}
							sx={{
								display: "flex",
								gap: 1,
								alignItems: "flex-start",
								mb: 1.5,
							}}
						>
							<TextField
								label="Campo"
								value={field.label}
								onChange={(e) => {
									const newFields = [...tempFields];
									newFields[index].label = e.target.value;
									setTempFields(newFields);
								}}
								size="small"
								sx={{ flex: 1, ...textFieldSx }}
							/>
							<TextField
								label="Valor"
								value={field.value}
								onChange={(e) => handleFieldChange(index, e.target.value)}
								size="small"
								sx={{ flex: 2, ...textFieldSx }}
							/>
							<IconButton
								onClick={() => handleDeleteField(index)}
								size="small"
								sx={{
									mt: 0.5,
									color: TRAVEL_KIT_MODAL.textMuted,
									"&:hover": {
										color: "#dc2626",
										bgcolor: "rgba(220, 38, 38, 0.08)",
									},
								}}
							>
								<DeleteIcon sx={{ fontSize: 18 }} />
							</IconButton>
						</Box>
					))}

					<Button
						onClick={handleAddField}
						startIcon={<AddIcon sx={{ fontSize: 18 }} />}
						sx={{
							textTransform: "none",
							fontSize: "13px",
							fontWeight: 600,
							color: TRAVEL_KIT_MODAL.primary,
							bgcolor: "rgba(99, 102, 241, 0.08)",
							borderRadius: TRAVEL_KIT_MODAL.radiusInput,
							border: `1px solid rgba(99, 102, 241, 0.25)`,
							mt: 1.5,
							"&:hover": {
								bgcolor: "rgba(99, 102, 241, 0.14)",
								borderColor: "rgba(99, 102, 241, 0.4)",
							},
						}}
					>
						Añadir campo
					</Button>

					<Box
						sx={{
							display: "flex",
							justifyContent: "flex-end",
							gap: 1.5,
							mt: 3,
						}}
					>
						<Button onClick={() => setEditModal(false)} sx={secondaryButtonSx}>
							Cancelar
						</Button>
						<Button
							variant="contained"
							onClick={handleSaveSection}
							sx={primaryButtonSx}
						>
							Guardar
						</Button>
					</Box>
				</Box>
			</BasicModal>
			</Box>

			{/* Modal editar título del header */}
			<Box className="hide-in-viewer">
			<BasicModal
				width={400}
				showModal={headerEditModal}
				handleClose={() => setHeaderEditModal(false)}
				contentSx={modalContentSx}
			>
				<Box sx={{ p: 3 }}>
					<Typography
						sx={{
							fontSize: "18px !important",
							fontWeight: 700,
							color: TRAVEL_KIT_MODAL.textPrimary,
							mb: 2,
							fontFamily: "'Inter', sans-serif",
						}}
					>
						Editar título de la página
					</Typography>
					<TextField
						label="Título"
						value={tempHeaderText}
						onChange={(e) => setTempHeaderText(e.target.value)}
						fullWidth
						size="small"
						margin="normal"
						placeholder="Ej: Info del Viaje"
						autoFocus
						sx={textFieldSx}
					/>
					<Box
						sx={{
							display: "flex",
							justifyContent: "flex-end",
							gap: 1.5,
							mt: 3,
						}}
					>
						<Button
							onClick={() => setHeaderEditModal(false)}
							sx={secondaryButtonSx}
						>
							Cancelar
						</Button>
						<Button
							variant="contained"
							onClick={handleSaveHeaderText}
							sx={primaryButtonSx}
						>
							Guardar
						</Button>
					</Box>
				</Box>
			</BasicModal>
			</Box>
		</Box>
	);
};

Template102.thumbnail = "/images/templates/template-tk-info.png";

export default Template102;
